<template>
  <div class="contactUs">
    <MdContactUs  class="MD"/>
    <PcContactUs class="PC"/>
  </div>
</template>

<script>
// 移动端
import MdContactUs from './MdContactUs.vue'
// pc端
import PcContactUs from './PcContactUs.vue'

export default {
  name: 'contactUs',
  components: {
    MdContactUs,
    PcContactUs
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .contactUs{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .contactUs{
    .MD{
      display: none;
    }
  }
}
</style>
